const paths = {
  root: "/",
  logout: "/logout",
  dashboard: "/dashboard",
  leaderboard: {
    root: "/leaderboard",
    byId: (id: string) => `/leaderboard/${id}`,
  },
  referral: {
    root: "/referral",
    history: "/referral/history",
  },
  user: {
    profile: "/user/profile",
    items: "/user/items",
    itemDetails: (id: string) => `/user/items/${id}`,
    transactions: "/user/transactions",
    entrypasses: "/user/entrypasseses",

  },
  nft: {
    root: "/nft/home",
    marketplace: "/nft/marketplace",
    nftCollection: "/nft/collections",
    // cart: "/nft/cart",
    buy: (id: string) => `/nft/buy/${id}`,
    myItems: (tokenId: string) => `/nft/my-items/${tokenId}`,
    migration: "/nft/migration",
    customize: (level: number, tokenId: string, id: string) => `/nft/customize/${level}/${tokenId}/${id}`,
    about: '/nft/about',
    type: (id: string) => `/nft/type/${id}`,
  },
  questions: "/questions",
  dailyTasks: "/daily-tasks",
  quests: {
    root: "/quests",
  },
  game: {
    cryptoHunt: "/game/crypto-hunt",
    jackpot: "/game/jackpot",
    pricePrediction: "/game/price-prediction",
  },
} as const;

export default paths;
